import type { FC } from "react";
import { Separator, Text, XStack } from "tamagui";

export const OrSeparator: FC<{ text: string }> = ({ text }) => {
  return (
    <XStack width={"100%"} alignItems="center">
      <Separator
        borderBottomWidth={"$0.2"}
        borderColor={"$gray-secondary-400"}
      />
      <Text
        paddingHorizontal={"$2"}
        fontFamily={"$subtitle"}
        fontWeight={"$4"}
        fontSize={"$2"}
        lineHeight={"$2"}
        color={"$gray-650"}
      >
        {text}
      </Text>
      <Separator
        borderBottomWidth={"$0.2"}
        borderColor={"$gray-secondary-400"}
      />
    </XStack>
  );
};
